export const ApiConstants = {
  baseUrl: '',
  endpoints: {
    framesDrawer: {
      exportPowerPoint: '/api/v1/AssortmentCanvas/ExportPowerPoint',
    },
    rightPanel: {
      candidateLibrary: '',
    },
    filters: {
      organisationData: '/api/v1/Organization/access',
      seasonDropdownData: '/api/v1/Organization/GetActiveSeasons',
      userDetails: '/api/v1/UserDetails/GetUserDetails',
      saveUserDetails: '/api/v1/UserDetails/SaveUserDetails',
      getColorList: '/api/v1/VisualArticle/GetAllColors',
    },
    canvasLobby: {
      createNewCanvas: '/api/v1/AssortmentCanvas/CreateCanvas',
      canvasCardData: '/api/v1/AssortmentCanvas/GetCanvases',
      deleteCanvas: '/api/v1/AssortmentCanvas/DeleteCanvas',
      updateCanvasName: '/api/v1/AssortmentCanvas/UpdateCanvasName',
      copyCanvas: '/api/v1/AssortmentCanvas/Copy',
    },
    canvas: {
      getCanvasById: '/api/v1/AssortmentCanvas/GetCanvasById',
      getObjects: '/api/v1/AssortmentCanvasObject/GetCanvasObjects?canvasId=',
      createUpdateObject: '/api/v1/AssortmentCanvasObject/CreateUpdateCanvasObject',
      deleteObject: '/api/v1/AssortmentCanvasObject/DeleteCanvasObject',
      deleteMultiObject: '/api/v1/AssortmentCanvasObject/DeleteCanvasMultiObjects',
      getArticleAttributes: '/api/v1/Article/GetProductsAndArticlesForCanvas?canvasId=',
      createGroupObject: '/api/v1/AssortmentCanvasObject/GroupCanvasObjects',
      ungroupObject: '/api/v1/AssortmentCanvasObject/UngroupCanvasObjects',
      createUpdateMultipleObject: '/api/v1/AssortmentCanvasObject/CreateUpdateCanvasMultiObjects',
      updateArticleAttributeToggle: '/api/v1/AssortmentCanvas/UpdateCanvasArticleAttributes',
      getObjectsToPresent:
        '/api/v1/AssortmentCanvasObject/GetCanvasObjectsForPresentation?canvasId=',
      getCollectionBuyingOptions:
        '/api/v1/Article/GetAscAttributeAllowedValues?attributeKey=collectionbuying',
      updateSACollectionBuying: '/api/v1/Article/UpdateAscSalesArticleAttributes',
      updateOneArticleCollectionBuying: '/api/v1/Article/UpdateAscOneArticleAttributes',
      // Always V2: it identifies the article by season article id, which only PAGE articles have.
      updatePageArticleCollectionBuying: '/api/v2/Article/UpdateAscSalesArticleAttributes',
    },
    image: {
      uploadImage: '/api/v1/Image/Upload',
      articleImageUpdate: '/api/v1/Image/UpdateArticleImage',
      connectToArticle: '/api/v1/Image/ConnectToArticle',
      disconnectFromArticle: '/api/v1/Image/DisconnectFromArticle',
    },
    articleBrowser: {
      getProductsAndArticles: '/api/v1/Article/GetProductsAndArticlesForMultipleDepartments',
      getTimeLineData: '/api/v1/Organization/GetSeasonTimelineData',
      createVisualArticle: '/api/v1/VisualArticle/CreateVisualArticle',
      getArticleById: '/api/v1/Article/GetArticleById',
    },
    visualArt: {
      updateVisualArt: '/api/v1/VisualArticle/UpdateVisualArticle',
      connectVisualArt: '/api/v1/VisualArticle/ConnectSalesArticle',
      getVisualArtDetails: '/api/v1/VisualArticle/GetVisualArticlesByIds',
    },
  },
}

const ARTICLE_API_VERSION_TIMEOUT_MS = 5000

let resolveArticleApiVersion: () => void
const articleApiVersionConfigured = new Promise<void>((resolve) => {
  resolveArticleApiVersion = resolve
})

export const configureArticleApiVersion = (usePageArticles: boolean): void => {
  const version = usePageArticles ? 'v2' : 'v1'
  ApiConstants.endpoints.canvas.getArticleAttributes = `/api/${version}/Article/GetProductsAndArticlesForCanvas?canvasId=`
  ApiConstants.endpoints.articleBrowser.getProductsAndArticles = `/api/${version}/Article/GetProductsAndArticlesForMultipleDepartments`
  ApiConstants.endpoints.articleBrowser.getArticleById = `/api/${version}/Article/GetArticleById`
  resolveArticleApiVersion()
}

// The PAGE articles toggle arrives over SignalR after the hub connects, which can be after the
// canvas starts loading articles. Wait for it, but fall back to the V1 endpoints if it never comes.
export const waitForArticleApiVersion = (): Promise<void> =>
  Promise.race([
    articleApiVersionConfigured,
    new Promise<void>((resolve) => setTimeout(resolve, ARTICLE_API_VERSION_TIMEOUT_MS)),
  ])
